import {createSelector} from 'reselect';

const getConfig = state => state.config;

export const selectconfigtype = createSelector([getConfig], config => config);
